export const FETCH_VERSION_RELEASE_DATA = 'FETCH_VERSION_RELEASE_DATA';
export const FETCH_VERSION_RELEASE_COUNT_DATA = 'FETCH_VERSION_RELEASE_COUNT_DATA';
export const CLEAR_VERSION_RELEASE_DATA = 'CLEAR_VERSION_RELEASE_DATA';
export const SET_VERSION_RELEASE_TABLE_PROPS = 'SET_VERSION_RELEASE_TABLE_PROPS';
export const SET_VERSION_RELEASE_FILTERS_APPLIED_FROM_REDIRECTION = 'SET_VERSION_RELEASE_FILTERS_APPLIED_FROM_REDIRECTION';
export const SET_VERSION_RELEASE_TABLE_LIST_LOADER = 'SET_VERSION_RELEASE_TABLE_LIST_LOADER';
export const SET_VERSION_RELEASE_LIST_REQUEST_HASH = 'SET_VERSION_RELEASE_LIST_REQUEST_HASH';

export const FETCH_CHARGER_ON_VERSION_TREND_DATA = 'FETCH_CHARGER_ON_VERSION_TREND_DATA';
export const SET_CHARGER_ON_VERSION_TREND_FILTER_HASH = 'SET_CHARGER_ON_VERSION_TREND_FILTER_HASH';
export const FETCH_LATEST_VERSION_INFO_DATA = 'FETCH_LATEST_VERSION_INFO_DATA';
export const SET_LATEST_VERSION_INFO_LOADER  = 'SET_LATEST_VERSION_INFO_LOADER';
export const SET_CHARGER_ON_VERSION_TREND_LOADER  = 'SET_CHARGER_ON_VERSION_TREND_LOADER'

export const FETCH_DEPLOYMENT_PROGRESS_TREND_DATA = 'FETCH_DEPLOYMENT_PROGRESS_TREND_DATA';
export const SET_DEPLOYMENT_PROGRESS_TREND_FILTER_HASH = 'SET_DEPLOYMENT_PROGRESS_TREND_FILTER_HASH';
export const SET_DEPLOYMENT_PROGRESS_TREND_LOADER  = 'SET_DEPLOYMENT_PROGRESS_TREND_LOADER'


export const FETCH_DEPLOYMENT_LOGS_DATA = 'FETCH_DEPLOYMENT_LOGS_DATA';
export const SET_DEPLOYMENT_LOGS_TABLE_LIST_LOADER = 'SET_DEPLOYMENT_LOGS_TABLE_LIST_LOADER';
export const SET_DEPLOYMENT_LOGS_LIST_REQUEST_HASH = 'SET_DEPLOYMENT_LOGS_LIST_REQUEST_HASH';
export const CLEAR_DEPLOYMENT_LOGS_DATA = 'CLEAR_DEPLOYMENT_LOGS_DATA';
export const SET_DEPLOYMENT_LOGS_TABLE_PROPS = 'SET_DEPLOYMENT_LOGS_TABLE_PROPS';
export const SET_DEPLOYMENT_LOGS_FILTERS_APPLIED_FROM_REDIRECTION = 'SET_DEPLOYMENT_LOGS_FILTERS_APPLIED_FROM_REDIRECTION';